import { computed } from 'vue';
import { useAccount } from './useAccount';

export function useContactPermissions() {
  const { currentAccount } = useAccount();

  const canDeleteContact = computed(() => {
    const features = currentAccount.value?.features ?? {};
    return !!features.allow_agent_contact_deletion;
  });

  return { canDeleteContact };
}
